var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-page',[_c('f7-navbar',{attrs:{"title":"KHÔNG TÌM THẤY TRANG","backLink":"Trở lại"}}),_c('f7-block',{attrs:{"strong":""}},[_c('p',[_vm._v("XIN LỖI")]),_c('p',[_vm._v("KHÔNG TÌM THẤY TRANG")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }